/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { ContentInformationClassNames } from './ContentInformation';

function Title({ className, children }) {
  return (
    <h1 className={ContentInformationClassNames.element('title', className)}>
      {children}
    </h1>
  );
}

Title.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Title.defaultProps = {
  className: '',
  children: undefined,
};

export default memo(Title);
